import ExpandableMobile from './ExpandableMobile';
import { withI18n } from 'react-i18next';

export default withI18n()(ExpandableMobile);
